
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection-view/[slug]",
      function () {
        return require("private-next-pages/collection-view/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection-view/[slug]"])
      });
    }
  